var Locale = {

  updateLocaleOnLogin: function(locale){
    Fraction.Helpers.setItem('updateLanguageOnLogin', locale);
  },

  // Extend the changeLocale function of i18n.js to allow overriding of
  // strings whenever the language is changed.
  changeLocale: function(locale, callback){
    i18n.changeLocale(locale, function(){
      // now this is the new part! override with branding texts!
      var keys = [];
      if (Fraction.Brand && Fraction.Brand.Text) {
        for(var k in Fraction.Brand.Text){
          if (Fraction.Brand.Text.hasOwnProperty(k)) {
            keys.push(k);
          }
        }
      }
      for (var i=0;i < keys.length;i++){
        var key = keys[i];
        var value = Fraction.Brand.Text[key];
        var parts = key.split(".").reverse();
        var current = value || false;
        for (var j=0;j < parts.length;j++){
          var part = parts[j];
          var tmp = {};
          tmp[part] = current;
          current = tmp;
        }
        i18n.extendLocale(current);
      }
      if (callback){
        callback();
      }
    });
  },

   map: {
     'ar': ['ar'],
     'bg': ['bg'],
     'ca': ['ca'],
     'cs': ['cs'],
     'cy': ['cy'],
     'da': ['da'],
     'de': ['de', 'de-at', 'de-ch', 'de-de', 'de-li'],
     'el': ['el'],
     'en': ['en', 'en-au', 'en-ca', 'en-in', 'en-nz', 'en-us', 'en-za'],
     'en-GB': ['en-gb'],
     'es': ['es', 'es-419', 'es-ar', 'es-cl', 'es-co', 'es-cr', 'es-es', 'es-hn', 'es-pe', 'es-us', 'es-uy', 'es-ve'],
     'es-MX': ['es-mx'],
     'fi': ['fi'],
     'fil': ['fil'],
     'fr': ['fr', 'fr-ch', 'fr-fr'],
     'fr-CA': ['fr-ca'],
     'ga': ['ga'],
     'he': ['he'],
     'hi': ['hi'],
     'is': ['is'],
     'it': ['it', 'it-ch', 'it-it'],
     'ja': ['ja'],
     'ko': ['ko'],
     'nl': ['nl'],
     'no': ['no'],
     'pl': ['pl'],
     'pt': ['pt', 'pt-pt'],
     'pt-BR': ['pt-br'],
     'ro': ['ro'],
     'ru': ['ru'],
     'sv': ['sv'],
     'th': ['th'],
     'tr': ['tr'],
     'vi': ['vi'],
     'zh-CN': ['zh-cn'],
     'zh-TW': ['zh-tw'],
   },

  getLanguage: (lang) => {
    const language = lang && lang.toLowerCase().replace("_", "-");
    const index = Object.keys(Locale.map).findIndex(key => Locale.map[key].indexOf(language) >= 0);
    return Object.keys(Locale.map)[index];
  },
};

module.exports = Locale;
